import { Collapse } from "bootstrap";

export default class Accordion {
    rootElement: HTMLElement;
    collapseElements: Collapse[];

    constructor(private uniqueID: string) {
        this.rootElement = document.getElementById(this.uniqueID) as HTMLElement;
        if (!this.rootElement) return;

        const accordion = this.rootElement.querySelector<HTMLAnchorElement>('a.toggle');
        if (!accordion) return;

        accordion.addEventListener('click', () => this.accordionClicked());
        this.initialiseAccordionGroup(accordion);
    }

    private initialiseAccordionGroup(accordion: HTMLAnchorElement) {
        const accordionContainer = accordion.closest<HTMLDivElement>('.dot-container:has(.widget-container), .widget-container:has(.widget-container), .flex-column-section-container');

        const otherAccordionCollapses = accordionContainer?.querySelectorAll<HTMLAnchorElement>(`.accordion [data-collapse-section]:not(#${this.uniqueID}.accordion [data-collapse-section])`);
        if (!otherAccordionCollapses || otherAccordionCollapses.length == 0) return;
        this.collapseElements = Array.from(otherAccordionCollapses).map(collapse => new Collapse(collapse, {toggle: false}));
    }

    private accordionClicked() {
        this.collapseElements?.forEach(col => col.hide());
    }
}